module.exports = __webpack_public_path__ + "media/images/hankyu_hakone_zh-hans01-93eac88ad89a620054f48f2e5e797191.jpg";